export default "__VITE_ASSET__DplS4EcI__"